import { HStack, Input } from '@chakra-ui/react';
import { DeleteOutlineIcon } from '@diamond/shared/icons';
import { IconButton, TextField } from '@diamond/shared/ui';
import { useFormContext } from 'react-hook-form';

import type { FormValues } from '../../types';

interface ProductRowProps {
  index: number;
  productId: string;
  onRemove: (index: number, productId: string) => void;
}

export const ProductRow = ({ index, productId, onRemove }: ProductRowProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<FormValues>();

  const handleRemove = () => {
    onRemove(index, productId);
  };

  return (
    <HStack alignItems="end">
      <TextField
        name={`products.${index}.product_title`}
        register={register}
        errors={errors}
        isRequired
        isDisabled
        border="none"
        _disabled={{ cursor: 'not-allowed' }}
      />
      <Input type="hidden" {...register(`products.${index}.product_id`)} />
      <IconButton
        icon={<DeleteOutlineIcon />}
        name="hapus-produk"
        aria-label="hapus-produk"
        color="white"
        bgColor="red"
        _hover={{ bgColor: 'maroon' }}
        _active={{ bgColor: 'red' }}
        onClick={handleRemove}
      />
    </HStack>
  );
};
